import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { Employee } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditEmployee from '@/components/employees/EditEmployee.vue';
    import TerminateEmployee from '@/components/employees/TerminateEmployee.vue';
    import Permission from '@/enums/Permission';
    import Delete from '@/components/Delete.vue';
    import { useRoles } from '@/composables/useRoles';
    import Role from '@/enums/Role';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeTableActions',
  props: {
    employee: {}
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { hasPermission } = usePermissions();
    const { hasAnyRole } = useRoles();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.employee }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).EMPLOYEES_UPDATE))
        ? (_openBlock(), _createBlock(EditEmployee, {
            key: 0,
            employee: _ctx.employee
          }, null, 8, ["employee"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).EMPLOYEES_UPDATE))
        ? (_openBlock(), _createBlock(TerminateEmployee, {
            key: 1,
            employee: _ctx.employee
          }, null, 8, ["employee"]))
        : _createCommentVNode("", true),
      (_unref(hasAnyRole)([_unref(Role).SUPER_ADMIN, _unref(Role).PAYROLL]))
        ? (_openBlock(), _createBlock(Delete, {
            key: 2,
            route: _ctx.route('v2.salary.employee.delete', { employeeId: _ctx.employee.id }),
            "query-key": [_unref(QueryKey).EMPLOYEES, selectedCompanyId.value],
            header: "employee.validation.are_you_sure",
            description: "employee.validation.delete_employee_confirm_text"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})